import { LandingPageEnum } from '../interfaces/user.interface';

export interface PostLoginRouteArgs {
  newUser: boolean;
  from: string | null;
  landingPage: LandingPageEnum | undefined;
  interestsRoute: string;
  dashboardRoute: string;
  feedRoute: string;
}

/**
 * Decides where to send a user after a successful login.
 *
 * TRIL-227: extracted from UserLogin's post-login navigation effect (TRIL-216)
 * so the branch order is unit-testable without rendering the full
 * Apollo + AuthContext + Redux stack. Behavior is identical to the inline
 * effect; returns null when no navigation should occur (the effect's
 * fall-through when no landing-page preference is set).
 */
export function resolvePostLoginRoute({
  newUser,
  from,
  landingPage,
  interestsRoute,
  dashboardRoute,
  feedRoute,
}: PostLoginRouteArgs): string | null {
  // newUser onboarding wins, even over a saved deep-link target.
  if (newUser) return interestsRoute;
  // Honor the preserved (already-validated) deep-link target.
  if (from) return from;
  // Fall through to the user's landing-page preference.
  if (landingPage === LandingPageEnum.DASHBOARD) return dashboardRoute;
  if (landingPage === LandingPageEnum.FEED) return feedRoute;
  return null;
}
